<template>
    <fwb-card class="col-span-5 hover:!bg-white dark:!bg-gray-700 dark:hover:!bg-gray-700" :class="props.class" >
        <div class="p-3 flex flex-col justify-between h-full">
            <div v-if="props.title || $slots.header" class="mb-2">
                <slot name="header">
                    <h5 v-if="props.title" class="text-md font-bold tracking-tight text-gray-700 dark:text-white antialiased">
                        {{props.title}}
                    </h5>
                </slot>
            </div>
            <slot></slot>
        </div>
    </fwb-card>
</template>
<script setup>
import { defineProps } from 'vue'
import { FwbCard } from 'flowbite-vue'
const props = defineProps({
    title: {
        type: String,
        default: null
    },
    class: {
        type: String,
        default: ''
    }
})
</script>